var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIkonerKiSokSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9998 4.33331C12.9998 9.38887 15.5276 11.9166 20.5832 11.9166C15.5276 11.9166 12.9998 14.4444 12.9998 19.5C12.9998 14.4444 10.4721 11.9166 5.4165 11.9166C10.4721 11.9166 12.9998 9.38887 12.9998 4.33331Z",
    stroke: "#ED8B00",
    strokeWidth: 1.51667,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIkonerKiSokSmall);
export default __webpack_public_path__ + "static/media/Ikoner_Ki-Sok_small.de77ce83a6e18f9917967cab2957a28c.svg";
export { ForwardRef as ReactComponent };